import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-cointainer">
      <span class="loader"></span>
    </div>
  );
};

export default Loader;
